import React, { useEffect, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import { getDoctorPatients } from "../../../db/users";
import { convertObjectToArray } from "../../../util/arraysUtil";
import Button from "../../../ui/Button/Button";
import Container from "../../../ui/Container/Container";
import { IoMdAddCircle } from "react-icons/io";
import List from "../../../ui/List/List";
import "./MainDoctor.css";

function MainDoctor() {
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);

  const [isFetching, setIsFetching] = useState(true);
  const [allPatients, setAllPatients] = useState([]);
  const [patients, setPatients] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    async function getPatients() {
      setIsFetching(true);
      const response = await getDoctorPatients(authCtx.userId, authCtx.token);
      if (!response.data) {
        setIsFetching(false);
      } else {
        const patientsArray = convertObjectToArray(response.data);
        setPatients(patientsArray);
        setIsFetching(false);
        setAllPatients(patientsArray);
      }
    }
    try {
      getPatients();
    } catch (error) {
      console.log(error);
    }
  }, []);

  function handleSearch(e) {
    const query = e.target.value;
    setSearchQuery(query);
    const formattedQuery = query.toLowerCase();
    const filteredData = allPatients.filter((patient) => {
      const fullItem = `${patient.patientInitials}: ${patient.patientName}`;
      return fullItem.toLowerCase().includes(formattedQuery);
    });
    setPatients(filteredData);
  }

  function optionPressed() {
    navigate("/technical");
  }

  function generateData() {
    const data = patients.map((p) => {
      return {
        key: p.key,
        value: `${p.patientInitials}: ${p.patientName}`,
        navigateTo: "/patientInfo",
        route: { patientKey: p.key },
      };
    });
    return data;
  }

  if (isFetching) {
    return (
      <div>
        <p>Cargando pacientes...</p>
      </div>
    );
  }

  if (authCtx.userId && patients) {
    return (
      <Container title="Opciones del doctor">
        <div className="mainDoctor">
          <div className="messageAndButton">
            <div>
              <p className="createMessage">Crear paciente nuevo</p>
            </div>
            <div className="add">
              <div
                onClick={() => {
                  navigate("/createPatient");
                }}
              >
                <IoMdAddCircle
                  style={{ fontSize: "48px", padding: "8px", color: "#FF2600" }}
                />
              </div>
            </div>
          </div>
          <div className="helpContainer">
            <Button onPress={optionPressed.bind(this, "technical")}>
              Ayuda técnica
            </Button>
          </div>
          {patients && (
            <div className="innerContainer">
              <input
                placeholder="Buscar paciente..."
                className="filter"
                autoCapitalize="none"
                onChange={handleSearch}
              />

              <List data={generateData()} height="80%" />
            </div>
          )}
        </div>
      </Container>
    );
  } else {
    return (
      <duv>
        <p>Cargando pacientes...</p>
      </duv>
    );
  }
}

export default MainDoctor;
